module.exports = __webpack_public_path__ + "felix-96d15c62e151db1792e6655e1894f056.webp";